<template>
    <div class="p-grid panel-demo">
        <h1 class="p-mx-auto">My Details</h1>
        <div class="p-col-12">
            <div class="card">
                <Toast/>
                <ProgressSpinner v-if="loadingStaff"/>
                <template v-else>
                    <Accordion :multiple="true" v-if="user">
                        <AccordionTab header="My Info" :active="true">
                            <p v-if="user.displayName">Name: {{ user.displayName }}</p>
                            <p v-if="user.jobTitle"> Job Title: {{ user.jobTitle }}</p>
                        </AccordionTab>
<!--                        <AccordionTab header="Curriculum Vitae" :active="true">-->
<!--                            <div class="orders-subtable p-mx-2 p-my-2">-->
<!--                                <DocumentDataTable :documents="Object.values(staff.documents)"-->
<!--                                                   :expansion="false"-->
<!--                                                   :loading="loading"-->
<!--                                                   @create-document="createDocument"-->
<!--                                                   @edit-document="editDocument"-->
<!--                                                   @confirm-delete-document="confirmDeleteDocument"-->
<!--                                                   @confirm-delete-selected-documents="confirmDeleteSelectedDocuments"-->
<!--                                                   @show-file-dialog="showFileDialog"/>-->
<!--                            </div>-->
<!--                        </AccordionTab>-->
                        <AccordionTab header="Academic Qualifications" :active="false">
                            <div class="orders-subtable p-mx-2 p-my-2">
                                <AcademicDataTable :academics="Object.values(staff.academics)"
                                                   :expansion="false"
                                                   :loading="loading"
                                                   @create-academic="createAcademic"
                                                   @edit-academic="editAcademic"
                                                   @confirm-delete-academic="confirmDeleteAcademic"
                                                   @confirm-delete-selected-academics="confirmDeleteSelectedAcademics"
                                                   @show-file-dialog="showFileDialog"/>
                            </div>
                        </AccordionTab>
                        <AccordionTab header="Professional Qualifications" :active="false">
                            <div class="orders-subtable p-mx-2 p-my-2">
                                <ProfessionalDataTable :professionals="Object.values(staff.professionals)"
                                                       :expansion="false"
                                                       :loading="loading"
                                                       :titles="titles"
                                                       :fullTitles="fullTitles"
                                                       :institutions="institutions"

                                                       @create-professional="createProfessional"
                                                       @edit-professional="editProfessional"
                                                       @confirm-delete-professional="confirmDeleteProfessional"
                                                       @confirm-delete-selected-professionals="confirmDeleteSelectedProfessionals"
                                                       @show-file-dialog="showFileDialog"/>
                            </div>
                        </AccordionTab>
                        <AccordionTab header="Trainings" :active="false">
                            <div class="orders-subtable p-mx-2 p-my-2">
                                <TrainingDataTable :trainings="Object.values(staff.trainings)"
                                                   :expansion="false"
                                                   :loading="loading"
                                                   @create-training="createTraining"
                                                   @edit-training="editTraining"
                                                   @confirm-delete-training="confirmDeleteTraining"
                                                   @confirm-delete-selected-trainings="confirmDeleteSelectedTrainings"
                                                   @show-file-dialog="showFileDialog"/>
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <div v-else>
                        <h5>Fail to get your account info. Please try again later.</h5>
                    </div>
                </template>
            </div>
        </div>

        <AcademicDialog ref="academicDialog" @updated="onItemsUpdated"/>
        <ProfessionalDialog ref="professionalDialog" @updated="onItemsUpdated" :professionalTitles="professionalTitles"/>
        <TrainingDialog ref="trainingDialog" @updated="onItemsUpdated"/>
        <DocumentDialog ref="documentDialog" @updated="onItemsUpdated"/>
        <FileDialog ref="fileDialog" @updated="onItemsUpdated"/>


    </div>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator'
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Toast from 'primevue/toast';
import Message from 'primevue/message';
import ProgressSpinner from 'primevue/progressspinner'
import StaffService from "@/service/StaffService";
import ProfessionalService from "@/service/ProfessionalService";
import store from "../store";
import AcademicDialog from "../components/dialog/AcademicDialog";
import StaffDialog from "../components/dialog/StaffDialog";
import ProfessionalDialog from "../components/dialog/ProfessionalDialog";
import TrainingDialog from "../components/dialog/TrainingDialog";
import DocumentDialog from "../components/dialog/DocumentDialog";
import FileDialog from "../components/dialog/FileDialog";
import AcademicDataTable from '../components/datatable/AcademicDataTable'
import ProfessionalDataTable from "../components/datatable/ProfessionalDataTable";
import TrainingDataTable from "../components/datatable/TrainingDataTable";
import DocumentDataTable from "../components/datatable/DocumentDataTable";

/**
 * Class-component
 */
@Component({
    components: {
        FileDialog,
        DocumentDataTable,
        TrainingDataTable,
        ProfessionalDataTable,
        AcademicDataTable,
        TrainingDialog,
        ProfessionalDialog,
        StaffDialog,
        AcademicDialog,
        DocumentDialog,
        Accordion: Vue.extend(Accordion),
        AccordionTab: Vue.extend(AccordionTab),
        Toast: Vue.extend(Toast),
        Message: Vue.extend(Message),
        ProgressSpinner: Vue.extend(ProgressSpinner)
    }
})
export default class Me extends Vue {
    staffService = new StaffService();
    staff = null;
    user = null;
    professionalTitles = [];
    selectedDocuments = [];
    titles = [];
    fullTitles = [];
    institutions = [];
    loadingStaff = false;
    loading = false;
    toastSuccess = {
        severity: 'success',
        summary: 'Successful',
        detail: '',
        life: 3000
    };
    toastError = {
        severity: 'error',
        summary: 'Error',
        detail: '',
        life: 3000
    };

    async mounted() {
        try {
            this.loadingStaff = true;
            await this.fetchProfessionals();
            if (Object.keys(store.state.user).length) {
                this.user = this.$store.state.user
                if (store.state.staffId) this.staff = await this.staffService.getStaffRelationships(store.state.staffId, ['academics', 'professionals', 'professionals.professional', 'trainings', 'documents', 'team'])
            }
            this.loadingStaff = false;

        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.staffService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }

    // File Dialog
    async showFileDialog(record) {
        try {
            this.loading = true;
            record = await store.dispatch('jv/get', [`${record._jv.type}/${record._jv.id}`, {params: {include: 'files', 'fields[files]': 'name,created-at'}}]);
            this.$refs.fileDialog.record = record;
            this.$refs.fileDialog.files = Object.values(record.files);
            this.$refs.fileDialog.fileDialog = true;
            this.loading = false;
        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.staffService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }

    // // Document Dialog
    // createDocument() {
    //     this.$refs.documentDialog.createDocument = false; // not showing the staff selections field
    //     this.$refs.documentDialog.document = {staff: {_jv: {id: this.staff["_jv"].id}}};
    //     this.$refs.documentDialog.documentDialog = true;
    // }
    //
    // async editDocument(document) {
    //     document.staff = {_jv: {id: this.staff["_jv"].id}}
    //     this.$refs.documentDialog.createDocument = false;
    //     this.$refs.documentDialog.document = {...document};
    //     this.$refs.documentDialog.documentDialog = true;
    // }
    //
    // confirmDeleteDocument(document) {
    //     this.$refs.documentDialog.document = document;
    //     this.$refs.documentDialog.deleteDocumentDialog = true;
    // }
    //
    // confirmDeleteSelectedDocuments(selectedDocuments) {
    //     this.$refs.documentDialog.selectedDocuments = selectedDocuments;
    //     this.$refs.documentDialog.deleteDocumentsDialog = true;
    // }

    // Academic Dialog
    createAcademic() {
        this.$refs.academicDialog.createAcademic = false; // not showing the staff selections field
        this.$refs.academicDialog.academic = {staff: {_jv: {id: this.staff["_jv"].id}}};
        this.$refs.academicDialog.academicDialog = true;
    }

    async editAcademic(academic) {
        academic.staff = {_jv: {id: this.staff["_jv"].id}}
        this.$refs.academicDialog.createAcademic = false;
        this.$refs.academicDialog.academic = {...academic};
        this.$refs.academicDialog.academicDialog = true;
    }

    confirmDeleteAcademic(academic) {
        this.$refs.academicDialog.academic = academic;
        this.$refs.academicDialog.deleteAcademicDialog = true;
    }

    confirmDeleteSelectedAcademics(selectedAcademics) {
        this.$refs.academicDialog.selectedAcademics = selectedAcademics;
        this.$refs.academicDialog.deleteAcademicsDialog = true;
    }

    // Professional Dialog
    createProfessional() {
        this.$refs.professionalDialog.createProfessional = false; // not showing the staff selections field
        this.$refs.professionalDialog.professional = {staff: {_jv: {id: this.staff["_jv"].id}}};
        this.$refs.professionalDialog.professionalMaster = {};
        this.$refs.professionalDialog.professionalDialog = true;
    }

    async editProfessional(professional) {
        professional.staff = {_jv: {id: this.staff["_jv"].id}}
        this.$refs.professionalDialog.createProfessional = false;
        this.$refs.professionalDialog.professional = {...professional};
        this.$refs.professionalDialog.professionalMaster = {...professional.professional};
        this.$refs.professionalDialog.professionalDialog = true;
    }

    confirmDeleteProfessional(professional) {
        this.$refs.professionalDialog.professional = professional;
        this.$refs.professionalDialog.deleteProfessionalDialog = true;
    }

    confirmDeleteSelectedProfessionals(selectedProfessionals) {
        this.$refs.professionalDialog.selectedProfessionals = selectedProfessionals;
        this.$refs.professionalDialog.deleteProfessionalsDialog = true;
    }

    // Training Dialog
    createTraining() {
        this.$refs.trainingDialog.createTraining = false; // not showing the staff selections field
        this.$refs.trainingDialog.training = {staff: {_jv: {id: this.staff["_jv"].id}}};
        this.$refs.trainingDialog.trainingDialog = true;
    }

    async editTraining(training) {
        training.staff = {_jv: {id: this.staff["_jv"].id}}
        this.$refs.trainingDialog.createTraining = false;
        this.$refs.trainingDialog.training = {...training};
        this.$refs.trainingDialog.trainingDialog = true;
    }

    confirmDeleteTraining(training) {
        this.$refs.trainingDialog.training = training;
        this.$refs.trainingDialog.deleteTrainingDialog = true;
    }

    confirmDeleteSelectedTrainings(selectedTrainings) {
        this.$refs.trainingDialog.selectedTrainings = selectedTrainings;
        this.$refs.trainingDialog.deleteTrainingsDialog = true;
    }

    // listen to items updated
    async onItemsUpdated() {
        this.staff = await this.staffService.getStaffRelationships(this.staff["_jv"].id, ['academics', 'professionals', 'professionals.professional', 'trainings', 'documents', 'team']);
    }

    async fetchProfessionals(){
        this.professionalTitles = await new ProfessionalService().fetchAvailableTitles();
    }


}
</script>

<style scoped>

</style>
